import Icon from '@components/atoms/icon/icon';
import React from 'react';
import useProductSalesConditionQuery from '@hooks/size-guide/use-product-sales-condition-query';
import SizeGuideWrapper from '@components/atoms/size-guide-wrapper/size-guide-wrapper';
import { Product } from '@interfaces/models/product';
import { Size } from '@interfaces/models/size';
import { useTranslation } from 'next-i18next';
import styles from './size-guide-filter.module.scss';

export type FilterContentProps = {
  sizeId: Size['id'];
  universeId: Product['universe']['id'];
} & React.HTMLProps<HTMLDivElement>;

const SizeGuideFilter: React.FC<FilterContentProps> = ({ sizeId, universeId }) => {
  const { t } = useTranslation();
  const { sizeStandard, categorySizeStandard } = useProductSalesConditionQuery();

  const label = categorySizeStandard ? categorySizeStandard[parseFloat(sizeId)] : '';

  if (!label) {
    return null;
  }

  return (
    <div className={styles.sizeGuideFilter}>
      <span>{label}</span>
      <SizeGuideWrapper
        universeId={universeId}
        productCategoryId={sizeId}
        sizeGuideStandard={sizeStandard}
      >
        <Icon
          name="info"
          className={styles.sizeGuideFilter__icon}
          ariaLabel={t('PLP.MYSIZES_DIALOG.SIZE_GUIDE')}
        />
      </SizeGuideWrapper>
    </div>
  );
};

export default SizeGuideFilter;
